import { TRACK } from '@disco/constants/ItemTypes'
import { getExtension } from '@disco/utils/file-utils'
import cuid from 'cuid'
import { taskRunner, prepareTempItems } from '@disco/utils/upload'
import type { UploadProvider } from 'types/upload'
import { uploadShortlistFile } from './utils'
const provider: UploadProvider = {
  id: 'local',
  title: 'Local Files',

  async upload(shortlistId, uploadId, tempItems, dispatch, getState) {
    const { csrfToken } = getState().user

    if (!taskRunner) return

    return tempItems.forEach(tempItem => {
      taskRunner.addTask({
        id: tempItem.tempId,
        func: uploadShortlistFile,
        params: [dispatch, getState, csrfToken, shortlistId, tempItem],
      })
    })
  },

  prepareTempItems(files: File[]) {
    return prepareTempItems(files)
  },
}
export default provider
